const COMPANIES = [
  { id: "c1", name: "אקמה בע\"מ",   domain: "acme.co.il",        created_at: "2024-01-15T00:00:00" },
  { id: "c2", name: "טכסטארט",      domain: "techstart.co.il",   created_at: "2024-02-20T00:00:00" },
  { id: "c3", name: "דיגיטאל פרו",  domain: "digitalpro.co.il",  created_at: "2024-03-10T00:00:00" },
];

const TECHNICIANS = [
  { id: "t1", first_name: "יוסי", last_name: "כהן",  email: "yosi@prodigy.co.il", phone: "050-1234567", is_admin: true,  created_at: "2024-01-01T00:00:00" },
  { id: "t2", first_name: "מירה", last_name: "לוי",  email: "mira@prodigy.co.il", phone: "052-2345678", is_admin: false, created_at: "2024-01-01T00:00:00" },
  { id: "t3", first_name: "אבי",  last_name: "שמש",  email: "avi@prodigy.co.il",  phone: "054-3456789", is_admin: false, created_at: "2024-01-01T00:00:00" },
];

const TICKETS = [
  {
    id: "tk1", ticket_number: 1001,
    title: "מחשב לא נדלק בבוקר",
    description: "המחשב של המשתמש לא נדלק בבוקר. ניסה לאתחל אך ללא הצלחה. נשמע צפצוף קצר בהפעלה.",
    sender_email: "david@acme.co.il", sender_name: "דוד ישראלי",
    company_id: "c1", company: COMPANIES[0],
    technician_id: "t1", technician: TECHNICIANS[0],
    status: "in_progress", priority: "high",
    opened_at: "2025-05-23T08:30:00", created_at: "2025-05-23T08:30:00", updated_at: "2025-05-23T09:00:00",
    is_sla_breach: false, has_customer_reply: false, last_customer_reply_at: null,
  },
  {
    id: "tk2", ticket_number: 1002,
    title: "בעיית חיבור לרשת WiFi",
    description: "המשתמשת לא מצליחה להתחבר לרשת הארגונית ב-WiFi מאז עדכון Windows שאתמול.",
    sender_email: "sara@techstart.co.il", sender_name: "שרה לוינסון",
    company_id: "c2", company: COMPANIES[1],
    technician_id: null, technician: null,
    status: "open", priority: "medium",
    opened_at: "2025-05-24T10:15:00", created_at: "2025-05-24T10:15:00", updated_at: "2025-05-24T12:10:00",
    is_sla_breach: false, has_customer_reply: true, last_customer_reply_at: "2025-05-24T12:10:00",
  },
  {
    id: "tk3", ticket_number: 1003,
    title: "Outlook לא שולח מיילים",
    description: "מאז אתמול בבוקר המיילים נתקעים ב-Outbox ולא יוצאים. קיבלתי הודעת שגיאה 0x80042109.",
    sender_email: "roi@acme.co.il", sender_name: "רועי אברהם",
    company_id: "c1", company: COMPANIES[0],
    technician_id: "t2", technician: TECHNICIANS[1],
    status: "pending", priority: "medium",
    opened_at: "2025-05-22T14:00:00", created_at: "2025-05-22T14:00:00", updated_at: "2025-05-23T11:00:00",
    is_sla_breach: true, has_customer_reply: false, last_customer_reply_at: null,
  },
  {
    id: "tk4", ticket_number: 1004,
    title: "התקנת מדפסת חדשה",
    description: "קיבלנו מדפסת HP LaserJet Pro M404dn וצריך להתקין אותה ברשת ולחבר את כל עמדות המשרד.",
    sender_email: "admin@digitalpro.co.il", sender_name: "נועה ברקוביץ",
    company_id: "c3", company: COMPANIES[2],
    technician_id: "t1", technician: TECHNICIANS[0],
    status: "open", priority: "low",
    opened_at: "2025-05-25T09:00:00", created_at: "2025-05-25T09:00:00", updated_at: "2025-05-25T09:00:00",
    is_sla_breach: false, has_customer_reply: false, last_customer_reply_at: null,
  },
  {
    id: "tk5", ticket_number: 1005,
    title: "מסך מראה שורות שחורות",
    description: "על מסך ה-Dell 27\" יש שורות שחורות אופקיות שמופיעות לסירוגין. הבעיה מתחזקת לאחר שעה.",
    sender_email: "moshe@techstart.co.il", sender_name: "משה גולן",
    company_id: "c2", company: COMPANIES[1],
    technician_id: null, technician: null,
    status: "open", priority: "high",
    opened_at: "2025-05-25T11:30:00", created_at: "2025-05-25T11:30:00", updated_at: "2025-05-25T13:45:00",
    is_sla_breach: false, has_customer_reply: true, last_customer_reply_at: "2025-05-25T13:45:00",
  },
  {
    id: "tk6", ticket_number: 1006,
    title: "שכחתי סיסמת Windows",
    description: "לא מצליח להיכנס לחשבון Windows שלי לאחר שהחלפתי סיסמה ושכחתי אותה.",
    sender_email: "tamar@acme.co.il", sender_name: "תמר שפירא",
    company_id: "c1", company: COMPANIES[0],
    technician_id: "t2", technician: TECHNICIANS[1],
    status: "closed", priority: "medium",
    opened_at: "2025-05-21T13:00:00", created_at: "2025-05-21T13:00:00", updated_at: "2025-05-21T15:30:00",
    is_sla_breach: false, has_customer_reply: false, last_customer_reply_at: null,
  },
  {
    id: "tk7", ticket_number: 1007,
    title: "VPN לא מתחבר מהבית",
    description: "עובד מרחוק ולא מצליח להתחבר ל-VPN הארגוני. מקבל שגיאת timeout בכל ניסיון.",
    sender_email: "yael@digitalpro.co.il", sender_name: "יעל מזרחי",
    company_id: "c3", company: COMPANIES[2],
    technician_id: null, technician: null,
    status: "open", priority: "high",
    opened_at: "2025-05-24T07:45:00", created_at: "2025-05-24T07:45:00", updated_at: "2025-05-24T07:45:00",
    is_sla_breach: true, has_customer_reply: false, last_customer_reply_at: null,
  },
  {
    id: "tk8", ticket_number: 1008,
    title: "Excel קורס בפתיחת קובץ גדול",
    description: "קובץ Excel עם 50,000 שורות גורם לאפליקציה לקרוס אחרי כמה דקות. המחשב מציג שגיאת זיכרון.",
    sender_email: "ilan@techstart.co.il", sender_name: "אילן נחמיאס",
    company_id: "c2", company: COMPANIES[1],
    technician_id: "t1", technician: TECHNICIANS[0],
    status: "in_progress", priority: "medium",
    opened_at: "2025-05-23T16:00:00", created_at: "2025-05-23T16:00:00", updated_at: "2025-05-24T08:00:00",
    is_sla_breach: false, has_customer_reply: false, last_customer_reply_at: null,
  },
];

const COMMENTS = {
  tk1: [
    { id: "cm1", body: "בדקתי - נראה שזו בעיית RAM. אזמין את המשתמש לאחר הצהריים.", body_html: null, source: null, email_from: null, is_internal: true,  ticket_id: "tk1", author_id: "demo-u1", author: { display_name: "Demo Admin" }, created_at: "2025-05-23T09:30:00", updated_at: "2025-05-23T09:30:00" },
    { id: "cm2", body: "שלום דוד, הטכנאי יגיע אליך בין 14:00-15:00 להחלפת הזיכרון.", body_html: null, source: null, email_from: null, is_internal: false, ticket_id: "tk1", author_id: "demo-u1", author: { display_name: "Demo Admin" }, created_at: "2025-05-23T10:00:00", updated_at: "2025-05-23T10:00:00" },
  ],
  tk2: [
    {
      id: "cm4",
      body: "שלום,\n\nניסיתי להתחבר שוב אבל עדיין לא עובד.\nהשגיאה שמתקבלת: \"Cannot connect to network.\"\n\nתודה,\nשרה",
      body_html: null,
      source: "email_inbound",
      email_from: "שרה לוינסון <sara@techstart.co.il>",
      is_internal: false,
      ticket_id: "tk2",
      author_id: null,
      author: null,
      created_at: "2025-05-24T12:10:00",
      updated_at: "2025-05-24T12:10:00",
    },
  ],
  tk3: [
    { id: "cm3", body: "בדקתי את ההגדרות - נראה שבעיה בהגדרת ה-SMTP server. ממתין לאישור IT של הלקוח.", body_html: null, source: null, email_from: null, is_internal: true, ticket_id: "tk3", author_id: "demo-u1", author: { display_name: "Demo Admin" }, created_at: "2025-05-22T15:00:00", updated_at: "2025-05-22T15:00:00" },
  ],
};

const HISTORY = {
  tk1: [
    { id: "h1", ticket_id: "tk1", event: "created",             label: "קריאה נפתחה",                    actor: "Demo Admin", created_at: "2025-05-23T08:30:00" },
    { id: "h2", ticket_id: "tk1", event: "status_changed",      label: "סטטוס שונה ל: בטיפול",            actor: "Demo Admin", created_at: "2025-05-23T09:00:00" },
    { id: "h3", ticket_id: "tk1", event: "technician_assigned", label: "טכנאי שובץ: יוסי כהן",            actor: "Demo Admin", created_at: "2025-05-23T09:00:00" },
    { id: "h4", ticket_id: "tk1", event: "comment_added",       label: "הערה פנימית נוספה",               actor: "Demo Admin", created_at: "2025-05-23T09:30:00" },
    { id: "h5", ticket_id: "tk1", event: "comment_added",       label: "הערה נוספה",                      actor: "Demo Admin", created_at: "2025-05-23T10:00:00" },
  ],
  tk3: [
    { id: "h6", ticket_id: "tk3", event: "created",             label: "קריאה נפתחה",                    actor: "Demo Admin", created_at: "2025-05-22T14:00:00" },
    { id: "h7", ticket_id: "tk3", event: "status_changed",      label: "סטטוס שונה ל: המתנה",             actor: "Demo Admin", created_at: "2025-05-23T11:00:00" },
    { id: "h8", ticket_id: "tk3", event: "comment_added",       label: "הערה פנימית נוספה",               actor: "Demo Admin", created_at: "2025-05-22T15:00:00" },
  ],
};

export const DEMO_USER = {
  id: "demo-u1",
  azure_id: "demo-azure-id",
  email: "admin@prodigy.co.il",
  display_name: "Demo Admin",
  role: "admin",
  is_active: true,
  department: "IT",
  phone: null,
  avatar_url: null,
  created_at: "2024-01-01T00:00:00",
  last_login: new Date().toISOString(),
};

// Mutable store so create/update/delete work within the session
export const store = {
  tickets: [...TICKETS],
  technicians: [...TECHNICIANS],
  companies: [...COMPANIES],
  comments: { ...COMMENTS },
  history: { ...HISTORY },
};
